/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Linkrequireddescription3Inputs */

const en_signin_linkrequireddescription3 = /** @type {(inputs: Signin_Linkrequireddescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the SMS link your clinic sent you to sign in. If you don't have it, ask the reception for a new one.`)
};

const fr_signin_linkrequireddescription3 = /** @type {(inputs: Signin_Linkrequireddescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisez le lien SMS envoyé par votre clinique pour vous connecter. Si vous ne l'avez pas, demandez à la réception de vous en envoyer un nouveau.`)
};

/**
* | output |
* | --- |
* | "Use the SMS link your clinic sent you to sign in. If you don't have it, ask the reception for a new one." |
*
* @param {Signin_Linkrequireddescription3Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const signin_linkrequireddescription3 = /** @type {((inputs?: Signin_Linkrequireddescription3Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Linkrequireddescription3Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signin_linkrequireddescription3(inputs)
	return fr_signin_linkrequireddescription3(inputs)
});
export { signin_linkrequireddescription3 as "signIn_linkRequiredDescription" }